module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h4 text-center"
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][1]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('p', {
    staticClass: " questionnaire-subhead mb-0"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][2]"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [_c('page-form', {
    on: {
      "tryForm": _vm.tryForm
    }
  })], 1)])]), _vm._v(" "), _c('thanks-demo-questionnaire-alert', {
    attrs: {
      "input": _vm.input
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02846d72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/Order/DemoQuestionnaire.vue
// module id = 665
// module chunks = 0